import type { EntryGateStatus } from '@core/entities/EntryGateStatus';
import type { EntryGateGateway } from '@core/ports/EntryGateGateway';

export class GetEntryGateStatusUseCase {
  public constructor(private readonly entryGateGateway: EntryGateGateway) {}

  public execute(): Promise<EntryGateStatus> {
    return this.entryGateGateway.getStatus();
  }
}